export enum PackingTypeEnum {
  DESCARTAVEL = 'DESCARTAVEL',
  RETORNAVEL = 'RETORNAVEL'
}
